module.exports = __webpack_public_path__ + "images/moonshot/tacoCompletionImage.10266869bbc99f5be3b3.svg";